<template>
    <div class="row ">
        <div
            class="input-field col s12"
            v-for="bolsa in bolsas"
            :key="bolsa.id"
        >
            <textarea
                v-if="!(disabled == undefined)"
                name="planoDeTrabalho"
                :id="'planoDeTrabalho' + bolsa.id"
                class="active materialize-textarea"
                :disabled="disabled"
                maxlength="2000"
                data-length="2000"
                v-model="bolsa.plano_trabalho"
            >
            </textarea>
            <label :for="'planoDeTrabalho' + bolsa.id" class="active"
                >Plano de trabalho para bolsa</label
            >
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "Bolsa",
    props: ["projectid", "disabled"],
    computed: {
        ...mapState({
            bolsas: state => state.project.bolsas
        })
    },
    watch: {
        bolsas(newValue, oldValue) {
        }
    },
    methods: {
        ...mapActions(["setBolsas"])
    },
	mounted() {
        var areas = document.getElementsByTagName('textarea'),
			i = areas.length;
			
		while (--i >= 0)
			M.textareaAutoResize(areas[i]);
    }
};
</script>
